import { Navigate, Outlet, useLocation } from "react-router-dom";

export default function OnboardingGuard() {
  const hasSeenOnboarding = localStorage.getItem("hasSeenOnboarding");
  const location = useLocation();

  // /pay/:token is fully public — never gate it
  if (location.pathname.startsWith("/pay")) {
    return <Outlet />;
  }

  if (!hasSeenOnboarding && location.pathname !== "/onboarding") {
    // Encode the full original path+search so onboarding can restore it
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/onboarding?next=${next}`} replace />;
  }

  return <Outlet />;
}